import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { ErrorStateMatcher, mixinErrorState } from '@angular/material/core';
import { Subject } from 'rxjs';

/**
 * Mixin for applying error state to mat-form-field controls
 * https://github.com/angular/components/blob/23dfbbb238b29fb3cc2bda680186cf0a9b8c40f1/src/material/input/input.ts#L55
 */
export const MatInputBase = mixinErrorState(class { // eslint-disable-line @typescript-eslint/naming-convention
  stateChanges: Subject<void>

  constructor(
    public _defaultErrorStateMatcher: ErrorStateMatcher,
    public _parentForm: NgForm,
    public _parentFormGroup: FormGroupDirective,
    public ngControl: NgControl
  ) {}
});
